import React, { useRef } from 'react';

const ShareScore = ({ score, username }) => {
    const canvasRef = useRef(null);

    const generateShareImage = () => {
        const canvas = canvasRef.current;
        if (!canvas) return null;

        const ctx = canvas.getContext('2d');
        canvas.width = 1080;
        canvas.height = 1920;

        // Background gradient
        const gradient = ctx.createLinearGradient(0, 0, 0, 1920);
        gradient.addColorStop(0, '#667eea');
        gradient.addColorStop(1, '#764ba2');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1080, 1920);

        // Title
        ctx.fillStyle = 'white';
        ctx.font = 'bold 80px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('🎮 PARABUL OYUNU', 540, 200);

        // Score box
        ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
        ctx.fillRect(140, 400, 800, 600);

        ctx.fillStyle = 'white';
        ctx.font = 'bold 60px Arial';
        ctx.fillText('SKORUN', 540, 500);

        ctx.font = 'bold 200px Arial';
        ctx.fillText(score.toString(), 540, 750);

        // Username
        ctx.font = 'bold 70px Arial';
        ctx.fillText(`@${username}`, 540, 900);

        // Call to action
        ctx.font = 'bold 60px Arial';
        ctx.fillText('Sen de oyna!', 540, 1150);

        ctx.font = '45px Arial';
        ctx.fillText('Bio\'daki linkten', 540, 1230);

        // Hashtags
        ctx.font = '40px Arial';
        ctx.fillText('#ParabulOyunu #ParabulChallenge', 540, 1350);

        return canvas.toDataURL('image/png');
    };

    const handleShare = async () => {
        const imageData = generateShareImage();

        if (!imageData) {
            alert('Görsel oluşturulamadı');
            return;
        }

        // Convert base64 to blob
        const blob = await (await fetch(imageData)).blob();
        const file = new File([blob], 'parabul-skor.png', { type: 'image/png' });

        // Try Web Share API (mobile)
        if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
            try {
                await navigator.share({
                    files: [file],
                    title: 'Parabul Oyunu Skorun',
                    text: `🎮 ${score} skor yaptım! Sen de oyna ve kazan! #ParabulOyunu`
                });
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Share failed:', error);
                    downloadImage(imageData);
                }
            }
        } else {
            // Fallback: Download image
            downloadImage(imageData);
        }
    };

    const downloadImage = (imageData) => {
        const link = document.createElement('a');
        link.download = 'parabul-skor.png';
        link.href = imageData;
        link.click();
    };

    return (
        <div className="share-score">
            <canvas ref={canvasRef} style={{ display: 'none' }} />

            <div className="share-info">
                <h3>📸 Skorunu Paylaş!</h3>
                <p>Story'de paylaş, arkadaşlarını etiketle!</p>
                <p className="share-benefit">✨ Daha fazla kişi görürse daha çok ödül!</p>
            </div>

            <button className="share-btn" onClick={handleShare}>
                📱 Story'e Paylaş
            </button>

            <div className="share-tips">
                <p><strong>💡 İpucu:</strong></p>
                <ul>
                    <li>Story'de <strong>@parabul</strong> etiketle</li>
                    <li>Hashtag kullan: <strong>#ParabulOyunu</strong></li>
                    <li>Arkadaşlarını etiketle!</li>
                </ul>
            </div>
        </div>
    );
};

export default ShareScore;
